import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import * as moment from 'moment';
import 'moment-duration-format';

@Component({
  selector: 'direction-details',
  templateUrl: './direction-details.component.html',
  styleUrls: ['./direction-details.component.scss']
})
export class DirectionDetailsComponent implements OnInit {

  @Input() directionDetails: any;
  @Input() direction: any;
  @Output() clearDestination: EventEmitter<any> = new EventEmitter();
  @Output() openNavigation: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  get estimatedTime(){
    return this.directionDetails ? this.directionDetails.summary.duration.text : '- -';
  }
  get estimatedDistance(){
    return this.directionDetails ? this.directionDetails.summary.distance.text : '- -';
  }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/direction-details/direction-details.component.ts